import { RouteName } from '@src/app/router/constants/RouteName';
import Router, { Route } from 'vue-router';
import { createCanonicalLink } from '../metaTags';
import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
import { getTimeFilterFromSlug } from '@shared/timeFilter/helpers';
import { TimeFilter } from '@shared/timeFilter/types';

export function updateSportsCanonicalTag(route: Route, router: Router): void {
    const timeFilterSlug = route.params?.timeFilter;
    if (route.name === RouteName.Sport.CategoryPerTime && timeFilterSlug) {
        const timeFilter = getTimeFilterFromSlug(timeFilterSlug);
        if (timeFilter !== TimeFilter.Live) {
            const url = router.resolve({
                name: RouteName.Sport.CategoryPerTime,
                params: {
                    sportSlug: route.params.sportSlug,
                    timeFilter: TimeFilterSlug.Today,
                },
            }).resolved.path;
            const canonicalUrl = window.location.origin + url;
            createCanonicalLink(canonicalUrl);
        }
    }
}
